import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-group__wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "form-group__tooltip"
}
const _hoisted_4 = ["id", "value", "checked", "disabled", "onClick"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTooltip = _resolveComponent("IconTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: $props.slug,
      class: _normalizeClass(["form-group__label", { disabled: $props.isDisabled, isSmall: $props.isSmallLabel }])
    }, [
      _createTextVNode(_toDisplayString($props.label) + ": ", 1 /* TEXT */),
      ($props.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_IconTooltip, {
              tooltipMessage: $props.description,
              isHtml: true
            }, null, 8 /* PROPS */, ["tooltipMessage"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filterValues, (filterItem, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "checkbox-item"
      }, [
        _createElementVNode("input", {
          type: "radio",
          class: "form-group__radio",
          id: `${$props.slug}_${index}`,
          value: filterItem.title,
          checked: index === $data.selectedIndex,
          disabled: filterItem.isDisabled || $props.isDisabled,
          onClick: ($event: any) => ($options.onRadioChange(index))
        }, null, 8 /* PROPS */, _hoisted_4),
        _createElementVNode("label", {
          for: `${$props.slug}_${index}`,
          class: _normalizeClass(["form-group__item-label", { disabled: filterItem.isDisabled }])
        }, [
          _createTextVNode(_toDisplayString(filterItem.title), 1 /* TEXT */),
          ($props.showNumResults)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(filterItem.numResults) + ")", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_5)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}